import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { decodeStorage } from 'functions/storageBase64'
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getStatement, getStatementOtherCard } from 'services/Movements';
import useTokenNew from './useTokenNew';

export function usePlanesPago(){

    const { isValid } = useTokenNew({name: 'usePlanesPago'})
    const history = useHistory();
    const cardendingPayment = decodeStorage('cardendingPayment')
    const noInternetPayment = decodeStorage('noInternetPayment')
    const pagoExpress = decodeStorage('pagoExpress')
    const lastConsultData = decodeStorage('lastConsultData')
    const [errorCode, setErrorCode] = useState()

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);

    const singlePlanData = {}

    if(pagoExpress){
        singlePlanData.cardending = pagoExpress?.cardending
        singlePlanData.minimum_to_pay = pagoExpress?.minimum_to_pay
        singlePlanData.monthly_payment = pagoExpress?.monthly_payment
        singlePlanData.new_balance_cutting = pagoExpress?.new_balance_cutting
        singlePlanData.payment_not_generate_interest = pagoExpress?.payment_not_generate_interest
        singlePlanData.credit_imit = pagoExpress?.credit_imit
    }else{
        singlePlanData.cardending = lastConsultData[0]?.cards[0]?.card_number.substr(-4)
        singlePlanData.minimum_to_pay = lastConsultData[0]?.minimum_to_pay
        singlePlanData.monthly_payment = lastConsultData[0]?.monthly_payment
        singlePlanData.new_balance_cutting = lastConsultData[0]?.new_balance_cutting
        singlePlanData.payment_not_generate_interest = lastConsultData[0]?.payment_not_generate_interest
        singlePlanData.credit_imit = lastConsultData[0]?.credit_imit
    }


    // Va al servicio para traer los planes de pago
    const [response, setResponse] = useState()
    useEffect(()=>{
        if(isValid){
            if(noInternetPayment){
                let cardendingP = pagoExpress?.cardending
                getStatementOtherCard(noInternetPayment, cardendingP)
                .then(setResponse)
            }
            else if(cardendingPayment){
                getStatement(cardendingPayment)
                .then(setResponse)
            }
            else{
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`)
            }
        }
    },[cardendingPayment, noInternetPayment, isValid])

    // Recibe la respuesta y segmenta los planes
    const [completePlanData, setCompletePlanData] = useState([])
    useEffect(()=>{
        if(response){
            if(response?.statusCode === 200){
                if(response?.data.payplans){
                    // console.log('response: ',response?.data.payplans)
                    setCompletePlanData(response?.data.payplans)
                }
            }
            else if(response?.statusCode >= 400 && response?.statusCode <= 499){
                let codeError = JSON.parse(response?.data)
                setErrorCode(codeError)
            }
            else if(response?.statusCode >= 500){
                setErrorCode(response?.statusCode)
            }
        }
    },[response])

    useEffect(()=>{
        if(errorCode <= 499){
            showModalErrorCode()
        }
    },[errorCode])
    
    const handleClose = () => {
        SetShowModal(false);
        if(cardendingPayment){
            if(completePlanData?.length <= 0){
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`)
            }
        }else if(noInternetPayment){
            if(completePlanData?.length <= 0){
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}informacion-tarjeta-express`)
            }
        }
    }

    return{
        singlePlanData,
        completePlanData,
        showModal,
        errorCode,
        setErrorCode,
        handleClose
    }
}